<template>
  <div class="container-loader vh-center position-absolute z-1">
    <div
      class="lds-ring vh-center position-absolute"
      v-b-tooltip.hover
      :title="tooltipTitle"
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "McContainerLoader",
  props: { tooltipTitle: { default: "" } },
};
</script>
